import { render } from "./TrendRadarTable.vue?vue&type=template&id=15b064cc&scoped=true"
import script from "./TrendRadarTable.vue?vue&type=script&lang=js"
export * from "./TrendRadarTable.vue?vue&type=script&lang=js"

import "./TrendRadarTable.vue?vue&type=style&index=0&id=15b064cc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15b064cc"]])

export default __exports__